import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "../registerServiceWorker";
import configureStore from "./store/configureStore";
import { initialState } from "./store/initialState";
import { StoreState } from "./store/storeState";
import { Store } from "redux";
import { HashRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "../polyfills";
import { authenticationSuccess } from "./actions/authActions";
import { Customer } from "./types/customer";

const store: Store<StoreState> = configureStore(initialState);

const customerString = sessionStorage.getItem("customer");
if (customerString) {
  const customer = JSON.parse(customerString) as Customer;
  if (customer) {
    store.dispatch(authenticationSuccess(customer));
  }
}

const renderApp = () => {
  return (
    // The Provider component is a special React-Redux component that provides the hooks to the
    // store.
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  );
};

function registerHMR() {
  type ModuleHMR = typeof module & {
    hot?: {
      accept(dependencies: string | string[], callback: (updatedDependencies: any[]) => void): void;
    };
  };
  if ((module as ModuleHMR).hot) {
    (module as ModuleHMR).hot!.accept("./App", () => {
      ReactDOM.render(
        <Provider store={store}>
          <HashRouter>
            <App />
          </HashRouter>
        </Provider>,
        document.getElementById("root") as HTMLElement
      );
    });
  }
}

ReactDOM.render(renderApp(), document.getElementById("root") as HTMLElement);

serviceWorker.unregisterServiceWorker();
registerHMR();

export { store };
